"use client"

import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import VerificationList from "./verification-list"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import type { ExhibitorVerification } from "./verification"

const VerificationContainer = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<ExhibitorVerification | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedItem(null)
    setModalOpen(true)
  }

  const handleOpenEdit = (item: ExhibitorVerification) => {
    setSelectedItem(item)
    setModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
    <Breadcrumbs mainTitle="Exhibitors Access Management" parent="Exhibitors" />
      <Container fluid>
        <Row>
          <Col md="12">
            <VerificationList onAdd={handleOpenAdd} onEdit={handleOpenEdit} refresh={refreshTrigger} />
          </Col>
        </Row>
        {/* Modal would go here if needed */}
        {modalOpen && <div>{/* Verification Modal Component */}</div>}
      </Container>
    </>
  )
}

export default VerificationContainer
